import { createFileRoute } from "@tanstack/react-router";
import { InvoiceDetail } from "@/components/InvoiceDetail";

export const Route = createFileRoute("/_auth/invoices/ap/$invoiceId")({
  component: APInvoiceDetailPage,
});

function APInvoiceDetailPage() {
  const { invoiceId } = Route.useParams();
  return <InvoiceDetail invoiceId={invoiceId} direction="ap" />;
}
